// extracted by mini-css-extract-plugin
export default {"this":"Inicio_this__a3ljS","block":"Inicio_block__YKNQp","line":"Inicio_line__Suk-F"};